// extracted by mini-css-extract-plugin
module.exports = {"subscriptions":"styles_subscriptions__1EC_C","cancelSubscription":"styles_cancelSubscription__C1opv"};